import Seo, { crumbsLd } from "@/components/site/Seo";
import { Breadcrumbs } from "@/components/site/Blocks";
import { getLegal } from "@/data/legal";
import { usePublicSettings } from "@/lib/publicSettings";

const LABELS = { legal_name: "Ragione sociale", legal_address: "Sede legale", vat: "Partita IVA", tax_code: "Codice fiscale", rea: "Registro Imprese / REA", share_capital: "Capitale sociale", pec: "PEC", other: "Altre informazioni" };

export default function LegalPage({ slug }) {
  const l = getLegal(slug);
  const { company } = usePublicSettings();
  const crumbs = [{ label: "Home", to: "/" }, { label: l.title, to: `/${l.slug}` }];
  return (
    <>
      <Seo path={`/${l.slug}`} title={`${l.title} | STUDIO WEB NS`} description={l.description} jsonLd={crumbsLd(crumbs)} />
      <article className="py-12 sm:py-16">
        <div className="wrap max-w-3xl">
          <Breadcrumbs items={crumbs} />
          <h1 className="text-4xl font-extrabold sm:text-5xl">{l.h1}</h1>
          <p data-testid="legal-draft-note" className="mt-6 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">{l.draft}</p>
          <div className="prose-swns">
            {l.sections.map((s) => <section key={s.h2}><h2>{s.h2}</h2><p>{s.p}</p></section>)}
            <section>
              <h2>Dati societari</h2>
              <dl className="mt-4 grid gap-2 text-sm">
                {Object.entries(LABELS).map(([k, label]) => (
                  <div key={k} className="grid grid-cols-[180px_1fr] gap-4 border-b border-slate-100 py-2">
                    <dt className="text-slate-600">{label}</dt>
                    <dd className="text-slate-900">{company[k] || <span className="text-slate-600">Da completare</span>}</dd>
                  </div>
                ))}
              </dl>
            </section>
          </div>
        </div>
      </article>
    </>
  );
}
